module.exports = __webpack_public_path__ + "front/img/code.8c0afb90.jpg";